import { useQuery } from '@tanstack/react-query';
import { fetchStores, fetchStore, checkDomainAvailability } from './request';
import {
  STORES_QUERY_KEY,
  STORE_QUERY_KEY,
  DOMAIN_CHECK_QUERY_KEY,
} from './key';

export const useStores = () => {
  return useQuery({
    queryKey: [STORES_QUERY_KEY],
    queryFn: fetchStores,
  });
};

export const useStore = (id?: string) => {
  return useQuery({
    queryKey: [STORE_QUERY_KEY, id],
    queryFn: () => fetchStore(id!),
    enabled: !!id,
  });
};

export const useCheckDomain = (domain: string) => {
  return useQuery({
    queryKey: [DOMAIN_CHECK_QUERY_KEY, domain],
    queryFn: () => checkDomainAvailability(domain),
    enabled: !!domain && domain.length > 0,
    retry: false,
  });
};
